import React from "react"
import {CmExternalLink} from "../../../packages/graphql-layer/src";
import CCOLink from "./CCOLink";
import {isTargetDownload} from "../../utility/navigationUtil";

interface Props {
    externalMenuLink?: boolean
    children?: JSX.Element
    name?: string
    noLinkIcon?: boolean
    onClick?: any
    openInTab?: boolean
    target?: any;
    type?: string
    dataCypress?: string
    className?: string
}

function CCOLinkable(props: Props) {
    // Do not show external link icon if it's a link to a download
    const noLinkIcon = props.noLinkIcon || isTargetDownload(props.target)

    if (props.target) {
        if (props.target.type === "CMExternalLink") {
            const externalTarget = props.target as CmExternalLink
            return <CCOLink className={props.className} dataCypress={props.dataCypress} openInTab={true} target={externalTarget} type={props.type} noLinkIcon={noLinkIcon}
                            onClick={props.onClick} externalMenuLink={props.externalMenuLink}>{props.children}</CCOLink>
        } else {
            const newTab = props.target.type === "SOSWimmelbild" ? true : props.openInTab
            return <CCOLink className={props.className} dataCypress={props.dataCypress}
                            openInTab={newTab}
                            target={props.target}
                            name={props.name}
                            type={props.type}
                            noLinkIcon={noLinkIcon}
                            onClick={props.onClick}>{props.children}</CCOLink>
        }
    } else {
        return props.children ? props.children : null
    }
}

export default CCOLinkable